export class EnvService {
  // Default values

  public linkPrefix = 'https://storage.googleapis.com/skillztank-1573503855694.appspot.com/';
  public appName = 'app';
  public maxusers = '100';
  public apiUrl = 'http://localhost:3200/';
  public socketUrl = 'http://localhost:3200/';
  public enableDebug = true;
  public production = false;
}
